import React from 'react';

export const PencilEditButtonIcon: React.FC<{ className?: string }> = ({
	className,
}) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.6736 1.88187L14.2221 0.423264C13.6611 -0.140437 12.7502 -0.140437 12.1874 0.423264L10.797 1.82046L14.0518 5.09117L15.6736 3.46141C16.1087 3.02417 16.1087 2.31908 15.6736 1.88187ZM9.94792 2.67041L13.2027 5.94108L4.96398 14.2201L1.71106 10.9495L9.94792 2.67041ZM0.457235 15.9888C0.190628 16.054 -0.0500532 15.8139 0.0091793 15.5461L0.831204 11.8345L4.08412 15.1051L0.457235 15.9888Z"
			/>
		</svg>
	);
};
